import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

/**
 * ExitIntentForm
 *
 * Renders the lead-magnet form inside the popup. Encapsulates form state and
 * submission so the host popup component stays small and presentational.
 */
const ExitIntentForm = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const cleanEmail = email.trim();
    if (!cleanEmail || submitting) return;
    setSubmitting(true);
    try {
      await axios.post(`${API}/lead`, {
        name: name.trim() || "amiga",
        email: cleanEmail,
        guide: "yoga-oncologico",
        source: "exit-popup",
      });
      toast.success("¡Listo! Revisa tu email en unos minutos.");
      onSuccess();
    } catch (err) {
      console.error("[exit-popup] submit failed:", err);
      toast.error("Algo ha fallado. Intenta de nuevo.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-3" data-testid="exit-popup-form">
      <input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Tu nombre (opcional)"
        data-testid="exit-popup-name"
        className="w-full px-4 py-3 rounded-full border border-sand/80 bg-white focus:border-terracotta focus:ring-1 focus:ring-terracotta outline-none text-charcoal text-sm"
      />
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Tu email"
        required
        autoFocus
        data-testid="exit-popup-email"
        className="w-full px-4 py-3 rounded-full border border-sand/80 bg-white focus:border-terracotta focus:ring-1 focus:ring-terracotta outline-none text-charcoal text-sm"
      />
      <button
        type="submit"
        disabled={submitting || !email}
        data-testid="exit-popup-submit"
        className="w-full bg-charcoal text-ivory rounded-full py-3.5 text-sm font-medium hover:bg-terracotta transition-colors disabled:opacity-60"
      >
        {submitting ? "Enviando…" : "Quiero la guía gratis"}
      </button>
      <p className="text-[11px] text-charcoal/50 text-center pt-1">
        Sin spam. Puedes darte de baja en cualquier momento.
      </p>
    </form>
  );
};

export default ExitIntentForm;
